import { render, staticRenderFns } from "./Bingo.vue?vue&type=template&id=36f8ff3c&scoped=true"
import script from "./Bingo.vue?vue&type=script&lang=js"
export * from "./Bingo.vue?vue&type=script&lang=js"
import style0 from "./Bingo.vue?vue&type=style&index=0&id=36f8ff3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f8ff3c",
  null
  
)

export default component.exports